import React from 'react';

// import LandingImgWoutBg from "../../images/impulse/img4R.png";
import './styles.css';

const LoadingAnimation = () => {
    return (
        <div className="loadingGrp" id="loaderGrp">
             {/* <div className="logo-container">
                <img src={gtslogo} alt="Logo" />
           </div> */}
            <div className="project-name">
                {/* <h1>Impulse</h1> */}
                {/* <img src={LandingImgWoutBg} alt="logo"/> */}
                <div className="wrappers">
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="shadow"></div>
                <div className="shadow"></div>
                <div className="shadow"></div>
                <span>Loading</span>
            </div>
           </div>
        </div>
    );
};

export default LoadingAnimation;
